<template>
  <HgModal
    v-model="showModal"
    class="hg-modal"
    transitionStyle="slide"
    :closeButtonCssClass="$style.modalClose"
    :containerCssClass="$style.modalContainer"
    data-test="contact-request-email-verification-code-modal"
    @close="emit('close')"
  >
    <ContactRequestEmailVerificationCodePanel
      :email="email"
      :contactRequestId="contactRequestId"
      isInModal
    />
  </HgModal>
</template>

<script lang="ts" setup>
import { HgModal } from '@smg-real-estate/domus';
import { computed } from 'vue';

import ContactRequestEmailVerificationCodePanel from './ContactRequestEmailVerificationCodePanel.vue';

defineOptions({
  name: 'ContactRequestEmailVerificationCodeModal',
});

interface Props {
  isVisible: boolean;
  email?: string;
  contactRequestId: string;
}

const props = withDefaults(defineProps<Props>(), {
  email: '',
});

const emit = defineEmits<{
  close: [];
}>();

const showModal = computed({
  get(): boolean {
    return props.isVisible;
  },
  set(value: boolean) {
    if (!value) {
      emit('close');
    }
  },
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

$modal-max-width: 396px;
$sharing-spacing: $space-75;
$modal-container-padding: 2rem;

.modalContainer {
  padding: $modal-container-padding;
  overflow: auto;
}

.modalClose {
  top: $space-25;
  padding: $sharing-spacing;
}

@media (min-width: $viewport-medium-min) {
  .modalContainer {
    width: $modal-max-width;
    height: initial;
  }
}
</style>
